import { onMounted, ref } from 'vue';

export const useSupportBox = () => {
  const hideSupportBoxKey = 'hide-support-box';
  const showSupportBox = ref(false);

  const hideSupportBox = () => {
    if (IS_SSR) {
      return null;
    }

    showSupportBox.value = false;

    try {
      window.sessionStorage.setItem(hideSupportBoxKey, 'true');
    } catch (error) {
      console.error(`error setting '${hideSupportBoxKey}' session storage item`, error);
    }
  };

  onMounted(() => {
    try {
      const hideSupportBox = window.sessionStorage.getItem(hideSupportBoxKey);
      showSupportBox.value = hideSupportBox !== 'true';
    } catch (error) {
      console.error(`error get '${hideSupportBoxKey}' session storage item`, error);
    }
  });

  return { showSupportBox, hideSupportBox };
};
